import { downloadIcon } from "../assets";
import { Button, Link } from "@nextui-org/react";
import React from "react";
import { downloadImage } from "../utilities";

const DownloadButton = ({ imageUrl }) => {
  console.log("Download button imageUrl: ", imageUrl);
  return (
    <Button className="absolute bottom-2 right-2 z-10 p-1 pr-1 opacity-0 transition-opacity duration-300 group-hover:opacity-100" isIconOnly as={Link} href={imageUrl} download={"generated_image"} variant="light" size="md" aria-label="Download">
      <img src={downloadIcon} alt="Download" className="h-9 w-9" />
    </Button>
  );
};

export default DownloadButton;
